import { mergeClassName as e } from "../../utils/data.js";
import { formatDate as t } from "../../utils/dates.js";
import { Calendar as ee } from "./Calendar.js";
import { useFormField as n } from "../FormField/useFormField.js";
import { FormField as r } from "../FormField/FormField.js";
import { DateFieldPopover as i } from "./DateFieldPopover.js";
import { HiddenDateInput as a } from "./HiddenDateInput.js";
import { useControlledDate as o, useDateEmitter as s, usePopoverOpen as c, useSyncedRef as l } from "./useDateField.js";
import { DateRangeInputTrigger as u } from "./DateRangeInputTrigger.js";
import { useCallback as te } from "react";
import { jsxDEV as d } from "react/jsx-dev-runtime";
import { CalendarBlankIcon as ne } from "@phosphor-icons/react";
//#region lib/components/DatePicker/DateRangePicker.tsx
var f = "/opt/render/project/src/shared-ui/lib/components/DatePicker/DateRangePicker.tsx";
function p({ fromValue: p, toValue: m, defaultFromValue: h, defaultToValue: g, fromProps: _, toProps: v, format: y = "iso", onFromChange: b, onToChange: x, onFromValueChange: S, onToValueChange: C, onBlur: w, label: re, helpText: T, errorMessage: E, fromPlaceholder: ie = "From", toPlaceholder: D = "To", disabled: O = !1, required: k, id: A, className: j, picker: M = "days", showFooter: N = !0, presets: P = !0, presetsOrientation: F = "right", numberOfMonths: I = 2, formatDateConfig: L, containerProps: R, inputTriggerProps: z, popoverProps: B, ...V }) {
	let { timeZone: H } = V, { fieldId: U, hasError: W, describedBy: G } = n({
		id: A,
		helpText: T,
		errorMessage: E
	}), K = l(_?.ref), q = l(v?.ref), J = o({
		value: p,
		defaultValue: h,
		format: y,
		timeZone: H
	}), Y = o({
		value: m,
		defaultValue: g,
		format: y,
		timeZone: H
	}), X = s(J.commit, {
		name: _?.name,
		onChange: b,
		onValueChange: S,
		registerOnChange: _?.onChange
	}), Z = s(Y.commit, {
		name: v?.name,
		onChange: x,
		onValueChange: C,
		registerOnChange: v?.onChange
	}), ae = te(() => {
		w?.({ target: K.current }), _?.onBlur?.({ target: K.current }), v?.onBlur?.({ target: q.current });
	}, [
		K,
		_,
		w,
		q,
		v
	]), { open: Q, handleOpenChange: $ } = c(ae), oe = () => {
		O || $(!0);
	};
	return /* @__PURE__ */ d(r, {
		id: U,
		label: re,
		helpText: T,
		errorMessage: E,
		containerProps: R,
		children: [
			/* @__PURE__ */ d(i, {
				open: Q,
				onOpenChange: $,
				trigger: /* @__PURE__ */ d(u, {
					hasError: W,
					active: Q,
					disabled: O,
					fromValue: t(J.date, {
						timeZoneDisplay: !1,
						timezone: H,
						...L
					}),
					toValue: t(Y.date, {
						timeZoneDisplay: !1,
						timezone: H,
						...L
					}),
					fromPlaceholder: ie,
					toPlaceholder: D,
					prefix: /* @__PURE__ */ d(ne, {
						size: 20,
						"aria-hidden": !0
					}, void 0, !1, {
						fileName: f,
						lineNumber: 149,
						columnNumber: 33
					}, this),
					describedBy: G,
					id: U,
					onOpen: oe,
					...z,
					className: e(j, z?.className)
				}, void 0, !1, {
					fileName: f,
					lineNumber: 133,
					columnNumber: 21
				}, this),
				...B,
				children: /* @__PURE__ */ d(ee, {
					mode: "range",
					value: {
						from: J.date,
						to: Y.date
					},
					numberOfMonths: I,
					presets: P,
					presetsOrientation: F,
					picker: M,
					showFooter: N,
					...V,
					onApply: (e) => {
						N && e && (X(e.from), Z(e.to), $(!1));
					},
					onChange: (e) => {
						!N && e && (X(e.from), Z(e.to));
					},
					onCancel: () => {
						$(!1);
					}
				}, void 0, !1, {
					fileName: f,
					lineNumber: 159,
					columnNumber: 17
				}, this)
			}, void 0, !1, {
				fileName: f,
				lineNumber: 129,
				columnNumber: 13
			}, this),
			/* @__PURE__ */ d(a, {
				ref: K,
				name: _?.name,
				value: J.value,
				format: y,
				timeZone: H,
				required: k
			}, void 0, !1, {
				fileName: f,
				lineNumber: 185,
				columnNumber: 13
			}, this),
			/* @__PURE__ */ d(a, {
				ref: q,
				name: v?.name,
				value: Y.value,
				format: y,
				timeZone: H,
				required: k
			}, void 0, !1, {
				fileName: f,
				lineNumber: 193,
				columnNumber: 13
			}, this)
		]
	}, void 0, !0, {
		fileName: f,
		lineNumber: 122,
		columnNumber: 9
	}, this);
}
//#endregion
export { p as DateRangePicker };
